import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import FotterMain from '../BaseComponents/FotterMain'
import Header from '../BaseComponents/Header'

import SEO from "../BaseComponents/SEO";
import useSeo from "../BaseComponents/SEO";


const EWasteManagement = () => {
    const toTop = () => {
        window.scrollTo(0, 0);
    }
    useEffect(() => {
        toTop();
    }, []);
    const seo = useSeo();
  const url = window.location.href;
  // console.log({url});
  const testurl =
  `${process.env.REACT_APP_PRO_MODE.replace(/\/$/, "")}${window.location.pathname}`;
  
    return (
        <>
             <SEO
       url={testurl}
      />
            <Header />
            <div className='innerpagebg pt-5 pb-5'>
                <div className='container mb-4'>
                    <div className='row'>
                        <div className='col-12  m-auto'>
                            <div className="align-items-center text-left">
                                <h4 className='d-inline-block m-0 fw-bold'>
                                    <span className='txtred'>E-</span><span className='txtdgray'>waste Management</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='row '>
                        <div className='col-lg-12 col-mg-12 col-sm-12 col-12 text-start m-auto'>
                            <div className='card p-3 rounded-0 shadow-sm pt-3'>
                                <div className='p-2'>
                                    <p>
                                        <strong>Honda India Power Products Limited</strong> has solely developed an internal standard procedure for collection and environment friendly recycling of e-waste abiding to all aspects of the E-Waste (Management) Rules, 2022, or as amended thereof by the regulator.
                                    </p>
                                    <p>
                                        We understand the importance of sound environment friendly recycling in the country and are willing to educate our internal and external consumers, partners, vendors etc., on the importance of E-Waste Management in our country.
                                    </p>
                                    <p>
                                        Besides, we have engaged with Waste Management Agencies (WMA) towards end-to-end fulfillment of Extended Producer Responsibility Compliances for our brand aligned to the CHAPTER VI (Modalities of the extended producer responsibility Regime) of the E-Waste (Management) Rules 2022.
                                    </p>
                                </div>
                                <ol className='pt-3'>
                                    <li><strong>Honda Authorised Waste Management Company</strong>
                                        <p className='mt-2'>
                                            <strong>WMA Name:</strong> Allied Waste Solutions Private Limited<br />
                                            <address>
                                                <strong>Reach-out:</strong> <a href="tel:+919990927652">+91 9990927652</a><br />
                                                <strong>Drop a line:</strong> <a href="mailto:info@alliedwastesolutions.com">info@alliedwastesolutions.com</a><br />
                                                <strong>Website:</strong> <a href="https://alliedwastesolutions.com/" target="_blank" rel="noopener noreferrer">alliedwastesolutions.com</a><br />
                                            </address>
                                        </p>
                                        <p className='mt-2'>At HSPP, we are committed to responsible recycling of our end-of-life products and urge all our customers to support our endeavor to collect E-Waste for eco-friendly recycling. Our focus is to reach out to as many States/UT as possible, to foster collection of E-Waste, towards environment friendly recycling towards extraction of critical metals aligned to the Govt. norms.
                                        </p>
                                    </li>
                                </ol>

                                <ol start="2">
                                    <li><strong>What is E-Waste?</strong>
                                        <p className='mt-2'>As per the E-Waste (Management) Rules 2022, electrical and electronic equipment' means equipment which are dependent on electric current or electro-magnetic field in order to become functional and also the equipment for the generation, transfer and measurements of the electricity.
                                        </p>
                                        <p>'e-waste' means electrical and electronic equipment, including solar photo-voltaic modules or panels or cells, whole or in part discarded as waste, as well as rejects from manufacturing, refurbishment and repair processes.
                                        </p>
                                    </li>
                                </ol>
                                <ol start="3">
                                    <li ><strong>Why Recycle E-waste?</strong>
                                        <ul className='mt-2'>
                                            <li><strong>Conserves Resources:</strong> Creation of new products requires raw materials. Recycling old products not only help reduce the extraction of fresh raw materials, but also conserve the environment.
                                            </li>
                                            <li><strong>Saves Energy:</strong> Recycling a product requires less energy than producing a new one from scratch. Skipping the usual process of extraction of virgin raw material, its transportation, refining, etc. saves energy.
                                            </li>
                                            <li><strong>Reduces Pollution:</strong> Through responsible recycling via authorized channels, we cut down air, water and land pollution, thus contributing towards a clean and green environment.
                                            </li>
                                        </ul>
                                    </li>
                                </ol>
                                <ol className='pt-3' start="4">
                                    <li><strong>How can you learn more about your E-Waste?</strong>
                                        <p className='mt-2'>For any queries related to e-waste management, please reach out to the below coordinates:- </p>
                                        <p className='mt-2'>
                                            <strong>WMA Name:</strong> Allied Waste Solutions Private Limited<br />
                                            <address>
                                                <strong>Reach-out:</strong> <a href="tel:+919990927652">+91 9990927652</a><br />
                                                <strong>Drop a line:</strong> <a href="mailto:info@alliedwastesolutions.com">info@alliedwastesolutions.com</a><br />
                                                <strong>Website:</strong> <a href="https://alliedwastesolutions.com/" target="_blank" rel="noopener noreferrer">alliedwastesolutions.com</a><br />
                                            </address>
                                        </p>

                                    </li>
                                </ol>


                                <ol start="5">
                                    <li><strong>What are your responsibilities as a Consumer/Bulk Consumer? </strong>

                                        <ul>
                                            <li>Look for information on the product or its packaging/brochure for e-waste management available with each of our products.
                                            </li>
                                            <li>Ensure that your e-waste gets recycled through authorized channels only and get treated through CPCB-authorized recyclers.
                                            </li>
                                            <li>Always drop your used electronic products, batteries or any accessories when they reach the end of their life at your nearest authorized e-waste collection/recycling point. You may get in touch with any of our empaneled Waste Management Companies for disposal of your generated E-Waste.
                                            </li>
                                            <li>Always disconnect the battery from product and ensure any glass surface is protected against breakage; this is to avoid any contamination of hazardous waste with the environment and prevent any environmental losses.
                                            </li>
                                            <li>Keep the product in isolated area, after it becomes non-functional/un-repairable so as to prevent its accidental breakage.
                                            </li>
                                            <li>
                                                Adopt a Lifestyle for Environment. To learn more, visit:
                                                <a href="https://missionlife-moefcc.nic.in/index.php" target="_blank" rel="noopener noreferrer">
                                                    https://missionlife-moefcc.nic.in/index.php
                                                </a>
                                            </li>
                                            <li>
                                                Spread the word about environmentally friendly E-Waste management and recycling to your near and dear ones.
                                            </li>
                                        </ul>

                                    </li>
                                </ol>
                                <div className='p-2'>
                                    <strong>Don’ts</strong>

                                    <ul>
                                        <li>Do not dismantle any electronics/ electrical devices or E-Waste at home. Improper dismantling or recycling of e-waste is harmful for the environment.
                                        </li>
                                        <li>E-Waste often contains harmful elements that not only degrades the environment, polluting air, water, land if treated informally, it also leads to health hazards in living organisms including humans. Do not ever burn or incinerate e-waste out in the open.
                                        </li>
                                        <li>Do not sell the e-waste to any unauthorized agencies/scrap dealer/informal waste collector, informal ragpickers, etc., as we understand that in most cases, the e-waste gets informally dismantled at unsafe working conditions which harms not just the environment, but also the people handling the e-waste with bare hands or with necessary precautions.
                                        </li>
                                        <li>Do not mix e-waste in your home dustbins with other municipal waste.
                                        </li>
                                        <li>Do not throw away batteries in trash bins.
                                        </li>
                                        <li>
                                            Do not keep irreparable or junk electronics stored at your home/office.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FotterMain />

        </>
    )
}

export default EWasteManagement